import React, { useState } from 'react'

import {
    Row,
    Col,
    Image
} from 'antd'

const MapaLotes = ({textos, mapa, enlace, english}) => {
    const redireccionSelect = e => {
        window.location = '/macrolote'
    }

    return (
        <Row align="middle" style={{paddingTop: 10, paddingBottom: 25}}>
            <Col xs={24} md={12}>
                <Image width="100%" src={mapa} />
            </Col>
            <Col xs={24} md={12} className="contenedor-bloques">
                <Row >
                    {textos.map((texto, index) => (
                        <p key={index} className="texto-proyecto">
                            {texto}
                        </p>
                    ))}
                </Row>
                <Row>
                    <a href={enlace}>
                        <button className="btn btn-claro">{english ? 'more information' :'más información'}</button>
                    </a>
                </Row>
            </Col>
        </Row>
    )
}

export default MapaLotes